'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const moment=require('pulsar-utils/dist-es6/time/moment');
const Formatters=require('../../../../../../../dist-es6/client/formatters');

const LocalMidnight=moment('1970-01-01');let
DoNotDisturbScheduleItemDirective=class DoNotDisturbScheduleItemDirective extends BaseControllerBackedDirective{
get objectBindings(){
return[
'schedule',
'togglePauseCommand',
'deleteCommand'];

}

get templateUrl(){
return'/templates/features/notificationSettings/components/doNotDisturbNotificationSettings/directives/doNotDisturbScheduleItemTemplate';
}

get controller(){
return DoNotDisturbScheduleItemController;
}};let


DoNotDisturbScheduleItemController=class DoNotDisturbScheduleItemController{
constructor(dateService){
this._startTimeOfDayLabel=this.getScheduleTime(this.schedule.startTimeOfDay);
this._endTimeOfDayLabel=this.getScheduleTime(this.schedule.endTimeOfDay);
this._scheduleTimezone=Formatters.formatInLocale(dateService.now(),'',this.schedule.timeZone,{displayTimeZone:!0});
this._isAllDaySchedule=this.schedule.startTimeOfDay===0&&this.schedule.endTimeOfDay===0;
}

onTogglePauseClicked(){
return this.togglePauseCommand.execute(this.schedule);
}

onDeleteClicked(){
return this.deleteCommand.execute(this.schedule);
}

getScheduleTime(millisecondsSinceMidnight){
return moment(LocalMidnight+millisecondsSinceMidnight).format('h:mm A');
}

get startTimeOfDayLabel(){
return this._startTimeOfDayLabel;
}

get endTimeOfDayLabel(){
return this._endTimeOfDayLabel;
}

get scheduleTimezone(){
return this._scheduleTimezone;
}

get isAllDaySchedule(){
return this._isAllDaySchedule;
}};


module.exports=DoNotDisturbScheduleItemDirective;
module.exports.controller=DoNotDisturbScheduleItemController;
//# sourceMappingURL=doNotDisturbScheduleItemDirective.js.map
